import { render, staticRenderFns } from "./customer-invoices.vue?vue&type=template&id=df704908"
import script from "./customer-invoices.vue?vue&type=script&lang=js"
export * from "./customer-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports